export const container = Symbol('container')
export const tablist = Symbol('tablist')



// WEBPACK FOOTER //
// ./src/js/util/symbols/tabs.js